<div class="text-center px-3 pt-3" data-testid="import-charge-confirm">
  <h2 id="import-charge-title" class="text-1 fs-4 fw-bold mb-3">{{ 'ITEMS.ImportChargeConfirmTitle' | translate }}</h2>
  <p class="mb-1" data-testid="import-charge-message" [innerHTML]="'ITEMS.ImportChargeConfirmMessage' | translate: params"></p>
  <p class="mb-4 text-muted small">{{ 'ITEMS.ImportChargeConfirmNote' | translate }}</p>
  <div class="d-flex flex-wrap justify-content-center gap-3 pb-2">
    <button type="button" class="btn btn-skyblue-s-1 standard-btn" data-testid="import-charge-cancel" (click)="answer(false)">{{ 'COMMON.Cancel' | translate }}</button>
    <button type="button" class="btn btn-p-2 standard-btn" data-testid="import-charge-yes" (click)="answer(true)">{{ 'ITEMS.ImportChargeConfirmYes' | translate }}</button>
  </div>
</div>
